import './index.pcss';
import $ from 'jquery';
import 'slick-carousel';
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'

$(window).on("load", function() {
    if (window.matchMedia("(min-width: 640px)").matches) {
        $('.slider-img-txt__slider-tablet-top').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            mobileFirst: true,
            asNavFor: '.slider-img-txt__slider-tablet-left'
        });

        $('.slider-img-txt__slider-tablet-left').slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            swipeToSlide: false,
            verticalSwiping: true,
            vertical: true,
            mobileFirst: true,
            asNavFor: '.slider-img-txt__slider-tablet-top',
            dots: false,
            arrows: false,
            focusOnSelect: true
        });
    }
    if (window.matchMedia("(max-width : 639px)").matches) {
        $('.slider-img-txt__top').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            draggable: false,
            mobileFirst: true,
            asNavFor: '.slider-img-txt__bottom'
        });

        $('.slider-img-txt__bottom').slick({
            slidesToShow: 4,
            slidesToScroll: 2,
            draggable: false,
            swipeToSlide: false,
            mobileFirst: true,
            arrows: false,
            infinite: false,
            swipe: true,
            asNavFor: '.slider-img-txt__top',
            focusOnSelect: true
        });

        let dataNumber = 0;

        window.addEventListener('touchstart', function() {
            dataNumber = Number($('.slider-img-txt__top').find('.slick-active').attr("data-slick-index"))
        });

        $('.slider-img-txt__bottom').on('swipe', function() {
            $('.slider-img-txt__top').slick('destroy');
            $('.slider-img-txt__top').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                arrows: false,
                draggable: false,
                mobileFirst: true,
                focusOnSelect: true,
                initialSlide: Number(dataNumber)
            });
        });

        $('.slider-img-txt__slider-wrapper-mobile img').on('click',function () {
            $('.slider-img-txt__popup-mobile').addClass('--active');
            $('.slider-img-txt__slider-wrapper-mobile-title').hide();
            $('.detail-page__inner').hide();
            $('.slider-img-txt__txt-info').hide();
            $('body').addClass('--no-scroll');
        });

        $('.slider-img-txt__popup-mobile .close').on('click',function () {
            $('.slider-img-txt__popup-mobile').removeClass('--active');
            $('.slider-img-txt__slider-wrapper-mobile-title').show();
            $('.detail-page__inner').show();
            $('.slider-img-txt__txt-info').show();
            $('body').removeClass('--no-scroll');
        });

        $('.link-txt').on('click', function (e) {
            e.preventDefault();
            $('.slider-img-txt__popup-mobile').addClass('--active');
            $('.slider-img-txt__slider-wrapper-mobile-title').hide();
            $('.detail-page__inner').hide();
            $('.slider-img-txt__txt-info').hide();
            $('body').addClass('--no-scroll');
        });
    }
});
